export default "__VITE_ASSET__9$9$vyFO__"